import React from 'react';

import Pagination from 'components/Pagination';

const RerpotListPagination = ({ options, onPageChange, loading, classNameWrapper = '' }) => {
  return (
    <div className={`wrapper mt-8 ${classNameWrapper}`}>
      <Pagination
        currentPage={options.page}
        totalPages={Math.ceil(options.total / options.page_size) ?? 0}
        onPageChange={onPageChange}
        loading={loading}
      />
    </div>
  );
};

export default React.memo(RerpotListPagination);
